module.exports = __webpack_public_path__ + "static/img/76.a5898a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/76.png
// module id = CVtp
// module chunks = 1